import { render, staticRenderFns } from "./filtersAndBreadCrumb.vue?vue&type=template&id=d2dc7a16&lang=pug"
import script from "./filtersAndBreadCrumb.vue?vue&type=script&lang=js"
export * from "./filtersAndBreadCrumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports